// extracted by mini-css-extract-plugin
module.exports = {"googleButton24":"signup-google_googleButton24__HYBB6","googleButtonLight24":"signup-google_googleButtonLight24__I3Md_","googleButtonLarge":"signup-google_googleButtonLarge__6VSEo"};